<template>
  <div>
    <HMTag>{{ $t('EVENTS.LABEL.FREE_EVENT') }}</HMTag>
  </div>
</template>

<script>
export default {
  name: 'EventFreeTagComponent',
};
</script>

<style scoped></style>
